import { getField } from 'app/components/SearchFilter/Constants';

/**
 * ATAI-204: the agent's only source of truth for "which filters are applied
 * right now" is the Search Filters panel's own chip list — redux `localFilter`,
 * the same array `SearchFilterNew`'s count badge renders (`localFilter.length`).
 *
 * The session context previously carried only `currentFilters` (redux `filter`,
 * via `selectFilter`), a different structure maintained by its own dispatch:
 * `applyResolvedSearch` updates `filter` and `localFilter` separately,
 * `updateLocalFilterAction` merges old chips by `apiKey` and drops ' or more'
 * names, and `setFilter` folds in `defaultFilter`. Nothing keeps the two the
 * same length, so a count taken from `filter` — or from the model's memory of
 * its own last tool call — can disagree with the number the user is looking at.
 * `currentFilters` stays in the context for the apply path; this is what the
 * model reports from.
 */
export function toAppliedFilterContext(localFilter) {
  return (localFilter || [])
    .filter((chip) => chip && chip.apiKey)
    .map((chip) => ({
      // `id` is the field's own label ("Bedrooms Min"), `name` the value as the
      // chip shows it ("5") — chipRecordValue/filterFieldLabel in
      // SearchChatPanel, leftLabel/option.label in the manual filter panels.
      label: chip.id,
      value: chipValue(chip),
      apiKey: chip.apiKey,
    }));
}

function chipValue(chip) {
  if (getField(chip.apiKey)?.type !== 'percent' || !chip.showALLDisplayValue) return chip.name;
  return chip.showALLDisplayValue.replace(/-?\d*\.?\d+/g, (n) =>
    String(Math.round(Number(n) * 10000) / 100)
  );
}
